import * as F from 'reduker/fp-utils'
import arrayToObjectByKeyObject from 'utils/arrayToObjectByKeyObject'

const getVendorInfo = vendor => {
  if (!vendor) return {}
  return {
    vendorId: vendor.id,
    homologated: vendor.homologated,
  }
}

export const invitationsToItemsInfo = invitations =>
  invitations.map(({ _links, _resource, ...invitation }) => {
    const vendor = getVendorInfo(_resource)
    return { ...invitation, ...vendor }
  })

export const invitationsToObjectsItemsInfo = F.pipe(
  invitationsToItemsInfo,
  arrayToObjectByKeyObject,
)

export const formatSearchOptions = options => {
  const formattedOptions = []
  if (options) {
    for (var key in options) {
      formattedOptions.push({
        id: options[key].hasOwnProperty('_resource')
          ? options[key]._resource.id
          : null,
        name: options[key].hasOwnProperty('_resource')
          ? options[key]._resource.name
          : options[key].name,
        pathname: options[key].hasOwnProperty('_resource')
          ? `/app/vendors/${options[key]._resource.id}`
          : null,
        back: { from: 'vendors' },
      })
    }
  }
  return formattedOptions
}
